import useAuth from 'app/hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';
import AuthLoadingScreen from 'app/components/AuthLoadingScreen';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isInitialised } = useAuth();
  const { pathname } = useLocation();

  // Show loading screen only for protected routes while auth is initializing
  if (!isInitialised) {
    return <AuthLoadingScreen currentPath={pathname} />;
  }

  if (isAuthenticated) return <>{children}</>;

  return <Navigate replace to="/session/signin" state={{ from: pathname }} />;
};

export default AuthGuard;
